export const Currencies = {
    0: {
        name: "",
        symbol: "",
        code: ""
    },
    1: {
        name: "US Dollar",
        symbol: "$",
        code: "USD"
    },
    2: {
        name: "New Israeli Shekel",
        symbol: "₪",
        code: "NIS"
    },
    3: {
        name: "Euro",
        symbol: "€",
        code: "EUR"
    },
    4: {
        name: "United Kingdom Pound",
        symbol: "£",
        code: "GBP"
    },
    5: {
        name: "Hungarian Forint",
        symbol: "Ft",
        code: "HUF"
    },
    6: {
        name: "Polish Zloty",
        symbol: "Zl",
        code: "PLN"
    },
    7: {
        code: "BGN",
        symbol: "BG",
        name: "Bulgarian Lev"
    },
    8: {
        code: "PHP",
        symbol: "₱",
        name: "Philippine Peso"
    },
    9: {
        code: "CAD",
        symbol: "C$",
        name: "Canadian Dollar"
    },
    10: {
        code: "RON",
        symbol: "lei",
        name: "Romanian Leu"
    },
    11: {
        code: "CHF",
        symbol: "CHF",
        name: "Swiss Franc"
    },
     12: {
        code: "CZK",
        symbol: "CZK",
        name: "Czech Koruna"
    },
}

export const CurrencyIds = {
    USD: 1,
    NIS: 2,
    EUR: 3,
    GBP: 4,
    HUF: 5,
    PLN: 6,
    BGN: 7,
    PHP: 8,
    CAD: 9,
    RON: 10,
    CHF: 11,
    CZK: 12,
}